/* tslint:disable */

declare var Object: any;
export interface EmployeeDataUpdateInterface {
  "id"?: number;
}

export class EmployeeDataUpdate implements EmployeeDataUpdateInterface {
  "id": number;
  constructor(data?: EmployeeDataUpdateInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `EmployeeDataUpdate`.
   */
  public static getModelName() {
    return "EmployeeDataUpdate";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of EmployeeDataUpdate for dynamic purposes.
  **/
  public static factory(data: EmployeeDataUpdateInterface): EmployeeDataUpdate{
    return new EmployeeDataUpdate(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'EmployeeDataUpdate',
      plural: 'EmployeeDataUpdate',
      path: 'EmployeeDataUpdate',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/EmployeeDataUpdate.ts